module.exports = __webpack_public_path__ + "static/img/815_phase_function_Paper_PointsHejduk_Prediction.7145702.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/815_phase_function_Paper_PointsHejduk_Prediction.png
// module id = 4Z4a
// module chunks = 0